import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import { http } from './providers/http'
import { validate } from 'vee-validate'

Vue.use(Router)

const routes = [
  {
    path: '/panel',
    name: 'panel',
    component: () => import('@/views/dashboard/Index'),
    children: [
      {
        name: 'Comprobantes',
        path: 'pages/comprobantes',
        component: () => import('@/views/dashboard/pages/PageComprobantes'),
        meta: { roles: ['COMPROBANTES'] },
      },
      {
        name: 'Préstamos',
        path: 'pages/prestamos',
        component: () => import('@/views/dashboard/pages/PageEstadosCuenta'),
        meta: { roles: ['COMPROBANTES'] },
      },
      {
        name: 'Dashboard',
        path: 'pages/dashboard_cuatrimestre',
        component: () => import('@/views/dashboard/pages/Dashboard_cuatrimestre'),
        meta: { roles: ['CUATRIMESTRE'] },
      },
      {
        name: 'Cuatrimestre',
        path: 'pages/cuatrimestre',
        component: () => import('@/views/dashboard/pages/Cuatrimestre'),
        meta: { roles: ['CUATRIMESTRE'] },
      },
      // {
      //   name: 'Asignación responsable',
      //   path: 'pages/asignacion_responsable_cuatrimestre',
      //   component: () => import('@/views/dashboard/pages/asignacion_responsable_cuatrimestre'),
      //   meta: { roles: ['CUATRIMESTRE'] },
      // },
      // {
      //   name: 'Tickets',
      //   path: 'pages/tickets',
      //   component: () => import('@/views/dashboard/pages/tickets'),
      //   meta: { roles: ['CUATRIMESTRE'] },
      // },
      {
        name: 'Perfil de usuario',
        path: 'pages/user',
        component: () => import('@/views/dashboard/pages/UserProfile'),
      },
      {
        name: 'Notifications',
        path: 'components/notifications',
        component: () => import('@/views/dashboard/component/Notifications'),
      },
      {
        name: 'Icons',
        path: 'components/icons',
        component: () => import('@/views/dashboard/component/Icons'),
      },
      {
        name: 'Typography',
        path: 'components/typography',
        component: () => import('@/views/dashboard/component/Typography'),
      },
      {
        name: 'Regular Tables',
        path: 'tables/regular-tables',
        component: () => import('@/views/dashboard/tables/RegularTables'),
      },
      {
        name: 'Google Maps',
        path: 'maps/google-maps',
        component: () => import('@/views/dashboard/maps/GoogleMaps'),
      },
      {
        name: 'Upgrade',
        path: 'upgrade',
        component: () => import('@/views/dashboard/Upgrade'),
      },
    ],
  },
  {
    name: 'MaintenanceMode',
    path: '/maintenance-mode',
    component: () => import('@/views/dashboard/pages/Maintenance'),
  },
  {
    path: '/historial-comprobantes',
    component: () => import('@/views/dashboard/Index'),
    children: [
      {
        name: 'historial-comprobantes',
        path: '/',
        component: () => import('@/views/dashboard/pages/PageCargarComprobantes'),
      },
    ],
  },
  {
    name: 'Login',
    path: '/',
    component: () => import('@/views/dashboard/pages/Login'),
    beforeEnter: async (to, from, next) => {
      let maintenance = (process.env.VUE_APP_MAINTENANCE_MODE === "true") || false;
      if (maintenance) {
        next({ name: "MaintenanceMode" });
      } else {
        next();
      }
    },
  },
  {
    name: 'AccessDenied',
    path: '/access-denied',
    component: () => import('@/views/dashboard/pages/AccessDenied'), // Ajusta la ruta al componente correspondiente
  },
  {
    path: '*',
    redirect: '/access-denied' // Redirigir a la página de acceso denegado para rutas no encontradas
  }
];

const router = new Router({
  mode: 'history',
  routes
});

router.beforeEach((to, from, next) => {
  let user_data = JSON.parse(localStorage.getItem('user'));

  if (to.matched.some(record => record.meta.roles)) {
    const roles = to.meta.roles || [];
    if (!roles.includes(user_data.tipo_usuario)) {
      return next({ name: 'AccessDenied' });
    }
  }
  next();
});

export default router;



